module.exports = __webpack_public_path__ + "img/blueBanner.90212b04.png";